import { computed } from 'vue'
import { required, email, helpers } from '@vuelidate/validators'

const phoneRegex = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/
const urlRegex = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/

export function useValidation(field: { type: string; optional: boolean }) {
  const rules = computed(() => ({
    value: {
      required: !field.optional
        ? helpers.withMessage('Dieses Feld darf nicht leer sein.', required)
        : false,
      validationRules: helpers.withMessage(
        getErrorMessage(field.type),
        (value: any, siblingState: any, vm: any) => {
          // If the field is optional and empty, it's valid
          if (field.optional && (value === '' || value === null || value === undefined)) {
            return true
          }

          // Apply specific validation based on field type
          switch (field.type) {
            case 'emailinput':
              return email.$validator(value, siblingState, vm)
            case 'numberinput':
              return !isNaN(Number(value))
            case 'phoneinput':
              return phoneRegex.test(value)
            case 'urlinput':
              return urlRegex.test(value)
            default:
              return true
          }
        }
      )
    }
  }))

  return {
    rules
  }
}

function getErrorMessage(fieldType: string): string {
  switch (fieldType) {
    case 'emailinput':
      return 'Bitte geben Sie eine gültige E-Mail-Adresse ein.'
    case 'numberinput':
      return 'Bitte geben Sie nur Zahlen ein.'
    case 'phoneinput':
      return 'Bitte geben Sie eine gültige Telefonnummer ein.'
    case 'urlinput':
      return 'Bitte geben Sie eine gültige URL ein.'
    default:
      return 'Ungültige Eingabe.'
  }
}
